<template>
  <div class="subscription-block">
    <subscribe :is-standalone="true"/>
  </div>
</template>

<script>
  import Subscribe from '~/components/subscribe'

  export default {
    name: 'SubscriptionBlock',

    components: {
      Subscribe
    }
  }
</script>

<style lang="scss" scoped>
  .subscription-block {
    @include centered-50()
  }
</style>
